export enum DownloadStatus {
	SUCCESS = 'success',
	ERROR = 'error',
	PENDING = 'pending',
}
